import React, { ReactElement, useEffect } from 'react';
import { useHistory, Link as RouterLink } from 'react-router-dom';
import useUser from 'hooks/useUser';
import Appbar from 'components/organisms/AppBar';
import Footer from 'components/organisms/Footer';
import axiosInterceptor from 'utils/axiosInterceptor';
import {
  Drawer,
  Toolbar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Grid,
  Divider,
  Link,
  Hidden
} from '@material-ui/core';
import useStyles from './adminTemplate.styles';
import validateRoutesByRole from 'services/validateRoutesByRole';
import { IRoute } from 'interfaces/route.interface';

axiosInterceptor();

interface Props {
  children: React.ReactNode;
}

export default function Admin({ children }: Props): ReactElement {
  const { logout, isLogged, user } = useUser();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const history = useHistory();
  const classes = useStyles();
  const routesByRole: IRoute[] = validateRoutesByRole(user?.roles) || [];

  const activeRoute = (routeName: string) => {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  };

  useEffect(() => {
    if (!isLogged) {
      logout();
      history.push('/login');
    }
  }, [isLogged]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const container = window !== undefined ? () => window.document.body : undefined;
  return (
    <div className={classes.root}>
      <CssBaseline />
      <Appbar logout={logout} routes={[]} accountText={user && user.email ? user.email : ''} />
      <Hidden smUp implementation="css">
        <Drawer
          container={container}
          variant="temporary"
          anchor={'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper
          }}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper
            }}
          >
            <Toolbar />
            <div>
              <List>
                {routesByRole.map((route: any) => (
                  <Link component={RouterLink} to={route.path} underline="none" color="inherit" key={route.path}>
                    <ListItem button key={route.path} className={classes.listItems} selected={activeRoute(route.path)}>
                      <ListItemIcon>
                        <route.icon />
                      </ListItemIcon>
                      <ListItemText primary={route.name} />
                    </ListItem>
                  </Link>
                ))}
              </List>
            </div>
          </Drawer>
        </Drawer>
      </Hidden>
      <Hidden xsDown implementation="css">
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper
          }}
        >
          <Toolbar />
          <div>
            <List>
              {routesByRole.map((route: any) => (
                <Link component={RouterLink} to={route.path} underline="none" color="inherit" key={route.path}>
                  {route.path && route.path == '/admin/inventoryManagement/IMWarehouse' ? <Divider /> : null}
                  <ListItem button key={route.path} className={classes.listItems} selected={activeRoute(route.path)}>
                    <ListItemIcon>
                      <route.icon />
                    </ListItemIcon>
                    <ListItemText primary={route.name} />
                  </ListItem>
                </Link>
              ))}
            </List>
          </div>
        </Drawer>
      </Hidden>
      <Grid container justify="center">
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.content}>{children}</div>
        </Grid>
        <Footer />
      </Grid>
    </div>
  );
}
